import { Card } from "../../reportDashboard/common/Card";

const COLORS = [
  "#1E61DC",
  "#10B981",
  "#F59E0B",
  "#8B5CF6",
  "#EC4899",
  "#6B7280",
];

export function PieChartShimmer({ segments = 6 }) {
  return (
    <Card className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
      <div className="w-full h-[350px] flex items-center justify-center relative">
        {Array.from({ length: segments }).map((_, idx) => (
          <div
            key={idx}
            className="absolute rounded-full animate-pulse"
            style={{
              width: `${120 + idx * 10}px`,
              height: `${120 + idx * 10}px`,
              border: `16px solid ${COLORS[idx % COLORS.length]}20`,
              borderTopColor: COLORS[idx % COLORS.length],
              animation: "spin 1s linear infinite",
            }}
          />
        ))}

        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </Card>
  );
}
